import { render } from "./CardTable.vue?vue&type=template&id=1313bb6d&scoped=true"
import script from "./CardTable.vue?vue&type=script&lang=js"
export * from "./CardTable.vue?vue&type=script&lang=js"

import "./CardTable.vue?vue&type=style&index=0&id=1313bb6d&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1313bb6d"]])

export default __exports__